/** @format */

import React, { Component } from 'react';
import { Header, Divider, Image, Grid, Button, Icon } from 'semantic-ui-react';
import './ClientMiniOverview.css';
import { getDateFromTimestamp } from '../../../helpers/getDateFromTimestamp';
import AvatarManImg from '../../../public/images/avatars/avatar-man.png';
import AvatarProfessionalImg from '../../../public/images/avatars/avatar-professional.png';
import { inject, observer } from 'mobx-react';

@inject('UserStore', 'ClientsStore', 'RequestsStore')
@observer
class ClientMiniOverview extends Component {
  getProfileAvatar = () => {
    let { ClientsStore } = this.props;
    let imgUrl = AvatarManImg;
    if (ClientsStore.currentClient.data.type === 'azienda') {
      imgUrl = AvatarProfessionalImg;
    }
    return imgUrl;
  };

  renderData = dataType => {
    let data = null;
    const { ClientsStore } = this.props;
    const currentClient = ClientsStore.currentClient;
    switch (true) {
      case dataType === 'avatar':
        if (
          currentClient.data.avatarLink !== '' &&
          currentClient.data.avatarLink !== undefined &&
          currentClient.data.avatarLink !== null
        ) {
          data = (
            <Image
              className="client-profile-image"
              src={this.getProfileAvatar()}
              circular
            />
          );
        } else {
          data = (
            <Image
              className="client-profile-image"
              src={this.getProfileAvatar()}
              circular
            />
          );
        }
        break;
      case dataType === 'timestamp':
        if (
          currentClient.data.timestamp !== '' &&
          currentClient.data.timestamp !== undefined &&
          currentClient.data.timestamp !== null
        ) {
          data = (
            <div>
              <strong>Utente dal</strong>{' '}
              {getDateFromTimestamp(currentClient.data.timestamp).split(' ')[0]}
            </div>
          );
        } else {
          data = (
            <div>
              <strong>Utente dal</strong> dal 01/01/2018
            </div>
          );
        }
        break;
      case dataType === 'payments':
        if (!currentClient.data.badPayer) {
          data = (
            <div>
              <Icon name="check" color="green" />{' '}
              <strong>Pagamenti Regolari</strong>
            </div>
          );
        } else {
          data = (
            <div>
              <Icon name="cancel" color="red" />{' '}
              <strong>Pagamenti da Verificare</strong>
            </div>
          );
        }
        break;
      case dataType === 'plate':
        data = (
          <div>
            <strong>Targa:</strong> {currentClient.data.plate}
          </div>
        );
        break;
      case dataType === 'sales':
        if (
          currentClient.data.salesNum !== '' &&
          currentClient.data.salesNum !== undefined &&
          currentClient.data.salesNum !== null
        ) {
          data = (
            <div>
              <strong>Vendite:</strong> {currentClient.data.salesNum}
            </div>
          );
        } else {
          data = (
            <div>
              <strong>Vendite:</strong> 0
            </div>
          );
        }
        break;
      case dataType === 'salesValue':
        if (
          currentClient.data.salesValue !== '' &&
          currentClient.data.salesValue !== undefined &&
          currentClient.data.salesValue !== null
        ) {
          data = (
            <div>
              <Icon name="dollar sign" color="black" />{' '}
              <strong>Valore Vendite:</strong> {currentClient.data.salesValue}€
            </div>
          );
        } else {
          data = (
            <div>
              <Icon name="dollar sign" color="black" />{' '}
              <strong>Valore Vendite:</strong> 0€
            </div>
          );
        }
        break;
      default:
    }
    return data;
  };

  renderCompleteClientButton = () => {
    const { ClientsStore } = this.props;
    // let clientId = getClientIdFromURL();
    // console.log(clientId);
    // if(clientId === '') {
    //     console.log('Preso dallo store');
    //     ClientsStore.clientsParams.currentClientId;
    // }
    let clientId = ClientsStore.clientsParams.currentClientId;
    let addressId = null;
    if (this.props.buttons) {
      return (
        <Grid.Row columns={2}>
          <Grid.Column>
            <Button
              size="small"
              onClick={() => {
                ClientsStore.toggleEditClientForm(clientId);
                ClientsStore.loadCurrentClient(clientId);
              }}
              color="green"
              fluid
            >
              <Icon name="user circle" />
              Completa profilo Cliente
            </Button>
          </Grid.Column>
          <Grid.Column>
            <Button
              size="small"
              onClick={() => {
                ClientsStore.toggleAddressForm(clientId, addressId);
              }}
              color="green"
              fluid
            >
              <Icon name="marker" />
              Aggiungi Indirizzo
            </Button>
          </Grid.Column>
        </Grid.Row>
      );
    } else {
      return null;
    }
  };

  renderResetClientButton = () => {
    let { RequestsStore, ClientsStore } = this.props;
    if (
      typeof RequestsStore.requestsParams.currentRequestId === 'undefined' ||
      RequestsStore.requestsParams.currentRequestId === null ||
      RequestsStore.requestsParams.currentRequestId === ''
    ) {
      return (
        <div
          className="close-button black"
          onClick={() => {
            ClientsStore.resetCurrentClient();
          }}
        >
          X
        </div>
      );
    }
  };

  render() {
    const { ClientsStore } = this.props;
    const currentClient = ClientsStore.currentClient;
    return (
      <div>
        <Grid>
          <Grid.Row>
            <Grid.Column
              computer={3}
              tablet={16}
              className="client-miniOverview-column"
            >
              {this.renderData('avatar')}
            </Grid.Column>
            <Grid.Column
              computer={13}
              tablet={16}
              className="client-miniOverview-column"
            >
              <Header as="h2">
                {currentClient.data.name} {currentClient.data.surname}
                <small>{' (' + currentClient.data.type + ')'}</small>
              </Header>
              <Divider />
              <Grid>
                <Grid.Row columns={2}>
                  <Grid.Column tablet={16} computer={8}>
                    {this.renderData('timestamp')}
                  </Grid.Column>
                  <Grid.Column tablet={16} computer={8}>
                    <Icon name="phone" color="black" />{' '}
                    {ClientsStore.currentClient.data.mobPhone !== ''
                      ? ClientsStore.currentClient.data.mobPhone
                      : ClientsStore.currentClient.data.landPhone}
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={2}>
                  <Grid.Column tablet={16} computer={8}>
                    {this.renderData('sales')}
                  </Grid.Column>
                  <Grid.Column tablet={16} computer={8}>
                    {this.renderData('salesValue')}
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={1}>
                  <Grid.Column tablet={16} computer={8}>
                    {this.renderData('plate')}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
          {this.renderCompleteClientButton()}
        </Grid>
        {this.renderResetClientButton()}
      </div>
    );
  }
}

export default ClientMiniOverview;
